module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_kimono-6f700efca6ec8506df6a102cf165ca75.webp";